<template>
  <el-form-item v-if="widget.options.filter(x => x.attrName == 'hide')[0]?!widget.options.filter(x => x.attrName == 'hide')[0].value:true" :label="widget.options.filter(x => x.attrName == 'formTitle').length>0?widget.options.filter(x => x.attrName == 'formTitle')[0].value:''" :prop="widget.model">
    <template v-if="widget.type == 'input'" >
      <el-input 
        v-if="widget.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType')[0].value == 'number' || widget.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType')[0].value == 'integer' || widget.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType')[0].value == 'float'"
        :type="widget.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType')[0].value"
        v-model.number="dataModel"
        :placeholder="widget.options.filter(x => x.attrName == 'placeholder')[0].value"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :maxlength="widget.options.filter(x => x.attrName == 'maxlength')[0].value"
      ></el-input>
      <el-input 
        v-else
        :type="widget.options.filter(x => x.attrName == 'regex')[0].list.filter(x => x.attrName == 'dataType')[0].value"
        v-model="dataModel"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :placeholder="widget.options.filter(x => x.attrName == 'placeholder')[0].value"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :maxlength="widget.options.filter(x => x.attrName == 'maxlength')[0].value"
      ></el-input>
    </template>

    <template v-if="widget.type == 'textarea'">
      <el-input type="textarea" :rows="5"
        v-model="dataModel"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :placeholder="widget.options.filter(x => x.attrName == 'placeholder')[0].value"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :maxlength="widget.options.filter(x => x.attrName == 'maxlengthtxt')[0].value"
      ></el-input>
    </template>

    <template v-if="widget.type == 'number'">
      <el-input-number 
        v-model="dataModel" 
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :step="widget.options.filter(x => x.attrName == 'step')[0].value"
        controls-position="right"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :maxlength="widget.options.filter(x => x.attrName == 'maxlength')[0].value"
      ></el-input-number>
    </template>

    <template v-if="widget.type == 'radio'">
      <el-radio-group v-model="dataModel"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
      >
        <el-radio
          :style="{display: widget.options.filter(x => x.attrName == 'inline')[0].value ? 'inline-block' : 'block'}"
          :label="item.value" v-for="(item, index) in (widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(x => x.attrName == 'remote')[0].value ? widget.options.filter(x => x.attrName == 'remoteOptions')[0].value : widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(x => x.attrName == 'remote')[0].options)" :key="index"
        >
          <template v-if="widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(x => x.attrName == 'remote')[0].value">{{item.label}}</template>
          <template v-else>{{widget.options.filter(x => x.attrName == 'showLabel')[0].value ? item.label : item.value}}</template>
        </el-radio>
      </el-radio-group>
    </template>

    <template v-if="widget.type == 'checkbox'">
      <el-checkbox-group v-model="dataModel"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
      >
        <el-checkbox
          
          :style="{display: widget.options.filter(x => x.attrName == 'inline')[0].value ? 'inline-block' : 'block'}"
          :label="item.value" v-for="(item, index) in (widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(x => x.attrName == 'remote')[0].value ? widget.options.filter(x => x.attrName == 'remoteOptions')[0].value : widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(x => x.attrName == 'remote')[0].options)" :key="index"
        >
          <template v-if="widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(x => x.attrName == 'remote')[0].value">{{item.label}}</template>
          <template v-else>{{widget.options.filter(x => x.attrName == 'showLabel')[0].value ? item.label : item.value}}</template>
        </el-checkbox>
      </el-checkbox-group>
    </template>

    <template v-if="widget.type == 'time'">
      <el-time-picker 
        v-model="dataModel"
        :is-range="widget.options.filter(x => x.attrName == 'isRange')[0].value"
        :placeholder="widget.options.filter(x => x.attrName == 'placeholder')[0].value"
        :start-placeholder="widget.options.filter(x => x.attrName == 'startPlaceholder')[0].value"
        :end-placeholder="widget.options.filter(x => x.attrName == 'endPlaceholder')[0].value"
        :readonly="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'readonly')[0].value"
        :disabled="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
        :editable="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'editable')[0].value"
        :clearable="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
        :arrowControl="widget.options.filter(x => x.list && x.list.length > 0 && x.attrName == 'attr')[0].list.filter(el => el.attrName == 'arrowControl')[0].value"
        :value-format="widget.options.filter(x => x.attrName == 'format')[0].value"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
      >
      </el-time-picker>
    </template>

    <template v-if="widget.type=='date'">
      <!-- :value-format="widget.options.filter(x => x.attrName == 'timestamp')[0].value ? 'timestamp' : widget.options.filter(x => x.attrName == 'format')[0].value" -->
      <el-date-picker
        v-model="dataModel"
        :type="widget.options.filter(x => x.attrName == 'type')[0].value"
        :placeholder="widget.options.filter(x => x.attrName == 'placeholder')[0].value"
        :readonly="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'readonly')[0].value"
        :disabled="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
        :editable="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'editable')[0].value"
        :clearable="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
        :format="widget.options.filter(x => x.attrName == 'format')[0].value"
        :value-format="widget.options.filter(x => x.attrName == 'valueformat')[0].value"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
      >
      </el-date-picker>
    </template>

    <template v-if="widget.type =='rate'">
      <el-rate v-model="dataModel"
        :max="widget.options.filter(x => x.attrName == 'max')[0].value"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :allow-half="widget.options.filter(x => x.attrName == 'allowHalf')[0].value"
      ></el-rate>
    </template>

    <template v-if="widget.type == 'color'">
      <el-color-picker 
        v-model="dataModel"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :show-alpha="widget.options.filter(x => x.attrName == 'showAlpha')[0].value"
      ></el-color-picker>
    </template>

    <template v-if="widget.type == 'select'">
      <el-select
        v-model="dataModel"
        :disabled="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
        :multiple="widget.options.filter(x => x.attrName == 'multiple')[0].value"
        :clearable="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
        :placeholder="widget.options.filter(x => x.attrName == 'placeholder')[0].value"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :filterable="widget.options.filter(x => x.attrName == 'filterable')[0].value"
        v-if="!widget.options.filter(x => x.attrName == 'hide')[0].value"
      >
        <el-option v-for="item in (widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].value ? widget.options.filter(x => x.attrName == 'remoteOptions')[0].value : widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].options)" 
          :key="item.value" 
          :value="item.value" 
          :label="item.label"></el-option>
      </el-select>
    </template>

    <template v-if="widget.type=='switch'">
      <el-switch
        v-model="dataModel"
        :active-value="widget.options.filter(x => x.attrName == 'activeValue')[0].value"
        :inactive-value="widget.options.filter(x => x.attrName == 'InActiveValue')[0].value"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
      >
      </el-switch>
    </template>

    <template v-if="widget.type=='slider'">
      <el-slider 
        v-model="dataModel"
        :min="widget.options.filter(x => x.attrName == 'min')[0].value"
        :max="widget.options.filter(x => x.attrName == 'max')[0].value"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :step="widget.options.filter(x => x.attrName == 'step')[0].value"
        :show-input="widget.options.filter(x => x.attrName == 'showInput')[0].value"
        :range="false"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
      ></el-slider>
    </template>

    <template v-if="widget.type=='imgupload'">
      <el-upload
        v-model="dataModel"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :class="[widget.options.filter(x => x.attrName == 'class')[0].value]"
        :multiple="widget.options.filter(x => x.attrName == 'multiple')[0].value"
        :action="widget.options.filter(x => x.attrName == 'action')[0].value"
        :accept="widget.options.filter(x => x.attrName == 'accept')[0].value"
        :data="{type:fileType,modelCode:widget.options.filter(x => x.attrName == 'modelCode')[0].value}"
        :show-file-list="widget.options.filter(x => x.attrName == 'showFile')[0].value"
        :headers="headers"
        :file-list="filelist"
        :list-type="widget.options.filter(x => x.attrName == 'listtype')[0].value"
        :on-success="success"
        :on-remove="handleRemove"
        :on-preview="handlePictureCardPreview"
      >
        <template v-if="widget.options.filter(x => x.attrName == 'listtype')[0].value == 'picture'">
          <el-button size="small" type="primary">点击上传</el-button>
        </template>
        <template v-else-if="widget.options.filter(x => x.attrName == 'listtype')[0].value == 'picture-card'">
          <i class="el-icon-plus"></i>
        </template>
        <template v-else>
          <img v-if="dataModel" :src="dataModel" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </template> 
      </el-upload>
      <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
        <img width="100%" :src="dataModel" alt="">
      </el-dialog>
    </template>

		<template v-if="widget.type == 'upload'">
      <el-upload
        v-model="dataModel"
        :disabled="widget.options.filter(x => x.attrName == 'disabled')[0].value"
        :style="{'width': widget.options.filter(x => x.attrName == 'width')[0].value}"
        :multiple="widget.options.filter(x => x.attrName == 'multiple')[0].value"
        :action="widget.options.filter(x => x.attrName == 'action')[0].value"
        :accept="widget.options.filter(x => x.attrName == 'accept')[0].value"
        :data="{type:fileType}"
        :show-file-list="widget.options.filter(x => x.attrName == 'showFile')[0].value"
        :headers="headers"
        :file-list="filelist"
        :list-type="widget.options.filter(x => x.attrName == 'listtype')[0].value"
        :on-success="success"
        :on-remove="handleRemove"
      >
       <el-button size="small" type="primary">{{widget.options.filter(x => x.attrName == 'btnname')[0].value}}</el-button> 
      </el-upload>
    </template>

    <template v-if="widget.type == 'editor'">
      <vue-editor
        v-model="dataModel"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
      >
      </vue-editor>
    </template>

    <template v-if="widget.type == 'cascader'">
      <el-cascader
        v-model="dataModel"
        :disabled="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'disabled')[0].value"
        :clearable="widget.options.filter(x => x.attrName == 'attr')[0].list.filter(el => el.attrName == 'clearable')[0].value"
        :placeholder="widget.options.filter(x => x.attrName == 'placeholder')[0].value"
        :style="{width: widget.options.filter(x => x.attrName == 'width')[0].value}"
        :options="widget.options.filter(x => x.attrName == 'remoteOptions')[0].value"
      >

      </el-cascader>
    </template>

    <template v-if="widget.type == 'text'">
      <span>{{dataModel}}</span>
    </template>
    
    <template v-if="widget.type == 'divider'">
      <el-divider :direction="widget.options.filter(x => x.attrName == 'direction')[0].value" :content-position="widget.options.filter(x => x.attrName == 'position')[0].value">{{widget.options.filter(x => x.attrName == 'defaultValue')[0].value}}</el-divider>
    </template>
  </el-form-item>
</template>

<script>
import FmUpload from './Upload'
import { VueEditor } from "vue2-editor"
let vm = {}

export default {
  props: ['widget', 'models', 'rules', 'remote'],
  components: {
    FmUpload,
    VueEditor
  },
  data () {
    vm = this;
    return {
      dataModel:this.models[this.widget.model],
      filelist:[],
      dialogVisible:false
    }
  },
  created () {
    if(this.widget.type == 'select' || this.widget.type == 'switch'){
      this.dataModel = parseFloat(this.models[this.widget.model]).toString() == "NaN" ? this.models[this.widget.model] : `${this.models[this.widget.model]}`
    }else{
      this.dataModel = this.models[this.widget.model]
    }

    const that = this;
    if (that.widget && that.widget.options.filter(x => x.attrName == 'dynamicChange').length>0 && that.widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].value && that.remote[that.widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].remoteFunc]) {
      that.remote[that.widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].remoteFunc]((data) => {
        if(that.widget.options.filter(x => x.attrName == 'remoteOptions').length>0){
          that.widget.options.filter(x => x.attrName == 'remoteOptions')[0].value = data.map(item => {
            return {
              value: item[that.widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].props.value],
              label: item[that.widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].props.label],
              children: item[that.widget.options.filter(x => x.attrName == 'dynamicChange')[0].list.filter(el => el.attrName == 'remote')[0].props.children]
            }
          })
        }
      })
    }
    
    if (that.widget && that.widget.type === 'imgupload' && that.widget.options.filter(x => x.attrName == 'isQiniu').length>0 &&that.widget.options.filter(x => x.attrName == 'isQiniu')[0].value) {
      that.remote[that.widget.options.filter(x => x.attrName == 'tokenFunc')[0].value]((data) => {
        that.widget.options.filter(x => x.attrName == 'token')[0].value = data
      })
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      if(this.widget.options.filter(x => x.attrName == 'listtype')[0].value == 'picture-card'){
        this.dataModel = file.url;
        this.dialogVisible = true;
      }
    },
    // 文件上传成功
    success(response, file, fileList){
      this.dataModel = fileList.map(x => x.response).toString()
    },
    // 移除事件
    handleRemove(file, fileList) {
      this.filelist.forEach((x,i) => {
        if(x.uid == file.uid){
          this.filelist.splice(i,1)
        }
      })
    },
  },
  computed:{
    headers(){
      return {"token":sessionStorage.getItem('tkn')}
    }
  },
  watch: {
    dataModel: {
      deep: true,
      handler (val) {
        this.models[this.widget.model] = val
        this.$emit('update:models', {
          ...this.models,
          [this.widget.model]: val
        })
        this.$emit('input-change', val, this.widget.model)
      }
    },
    models: {
      deep: true,
      handler (val) {
        if(this.widget.type == 'select' || this.widget.type == 'switch'){
          this.dataModel = parseFloat(val[this.widget.model]).toString() == "NaN" ? val[this.widget.model] : val[this.widget.model].toString()
        }else{
          this.dataModel = val[this.widget.model]
        }
      }
    }
  }
}
</script>
<style scoped>
.el-form-item /deep/ .el-form-item__label{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/vueformmaking/GenerateFormItem.vue